/** Compact credit balance display in sidebar — clickable, navigates to /billing */

import { useNavigate } from 'react-router-dom'
import { Coins } from 'lucide-react'
import { cn } from '../../lib/utils'
import { useCreditBalance } from '../../hooks/use-credits'

interface Props {
  isDark: boolean
  onNavigate?: () => void
}

export function CreditBalanceWidget({ isDark, onNavigate }: Props) {
  const navigate = useNavigate()
  const { data: balance, isLoading } = useCreditBalance()

  const handleClick = () => {
    navigate('/billing')
    onNavigate?.()
  }

  const total = balance?.totalCredits ?? 0
  const display = isLoading ? '—' : total.toLocaleString()

  return (
    <button
      onClick={handleClick}
      className={cn(
        'flex w-full items-center justify-between rounded-lg px-2 py-2 text-sm md:py-1.5 md:text-xs',
        isDark
          ? 'text-neutral-400 hover:bg-surface-3 hover:text-neutral-200'
          : 'text-neutral-500 hover:bg-neutral-100 hover:text-neutral-800',
      )}
      title="Manage billing"
    >
      <span className="flex items-center gap-2">
        <Coins className="h-4 w-4 md:h-3.5 md:w-3.5" />
        <span>Credits</span>
      </span>
      <span className={cn('font-medium tabular-nums', isDark ? 'text-neutral-200' : 'text-neutral-700')}>
        {display}
      </span>
    </button>
  )
}
